import React, {useEffect, useState} from "react";
import ViberHeader from "../../../components/header-new/ViberHeader";
import {Col, Container, Row} from "reactstrap";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import {searchCertificatesGeneratedEnrolls} from "../../../services/courses";
import CourseCertificateCard from "../../../components/CourseCertificateCard";
import NotFound from "../../../components/NotFound/NotFound";

export default function Certificates() {

    const [courseEnrollDetails, setCourseEnrollDetails] = useState([])

    useEffect(() => {
        (async function fetch() {
            const result = await searchCertificatesGeneratedEnrolls();

            if (result) {
                const {success, body} = result;
                if (success && body) {
                    setCourseEnrollDetails(body);
                }
            }
        })
        ()
    }, []);

    return (
        <div>
            <ViberHeader/>
            <div style={{marginTop: 40}}>
                <Container fluid style={{border: '1px solid none'}}>
                    <Row style={{display: "flex", justifyContent: 'center', alignItems: 'center'}}>
                        {
                            courseEnrollDetails.length === 0 &&
                            <div style={{marginTop:'200px'}}>
                                <NotFound messageOnly={true} message={"There's no issued certificates to display."}/>
                            </div>
                        }
                        {
                            courseEnrollDetails.map(courseEnrollDetail => {

                                const {course, courseEnrollmentId, studentId, certificateId} = courseEnrollDetail;

                                return (
                                    <Col key={`${courseEnrollmentId}${studentId}${certificateId}`} sm={12} md={12} lg={5} xl={5} style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginBottom: "20px"
                                    }}>
                                        <CourseCertificateCard key={`${courseEnrollmentId}${studentId}${certificateId}`}
                                                               course={course} certificateId={certificateId}/>
                                    </Col>
                                );
                            })
                        }
                    </Row>
                </Container>
            </div>

            <div style={{marginTop: courseEnrollDetails.length === 0? '100vh': 400}}>
                <CardsFooter/>
            </div>
        </div>
    );
}